import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { PromocodeHasPackageAction } from './promocode-has-package.action';

/* @ngInject */
export default class PromocodeHasPackageController implements ActionHandler {
  private url: string;
  private dialogElement;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element
      .find('#promocode-has-package')
      .remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof PromocodeHasPackageAction) {
      this.url = action.url;
      this.openDialog();
    }
  }

  public onClick() {
    this.dialogElement.close();
    window.location.href = this.url;
  }

  private openDialog() {
    this.dialogElement.open();
  }

  private close() {
    this.dialogElement.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/promocode-has-package/promocode-has-package.controller.ts